export const siteName = "Landrr Docs";

const GITHUB_URL = "https://github.com/valtterisa/landrr.js";
const SITE_URL = "https://valtterisa.github.io/landrr.js/";

export const docNav = [
  { label: "Overview", href: "/" },
  { label: "Getting started", href: "/getting-started" },
  { label: "SSR", href: "/ssr" },
  { label: "SSG", href: "/ssg" },
  { label: "SEO", href: "/seo" },
  { label: "Deploy", href: "/deployment" },
  { label: "Site", href: SITE_URL },
  { label: "GitHub", href: GITHUB_URL },
];

export const footer = {
  copyright: "© 2026 Landrr.js. MIT License.",
  links: [
    { label: "GitHub", href: GITHUB_URL },
    { label: "Project site", href: SITE_URL },
  ],
};
